const ALLOWLIST_ENV = new Set(['staging', 'dev', 'test']);

/**
 * Reads the changeboarding query parameter to force-enable a specific feature's
 * changeboarding experience. This bypasses feature gating/experiments and
 * killswitch checks, but MUST NOT bypass the Valtio "seen" state in rendering
 * code. Use only to decide gating in isFeatureEnabled, and for devloop.
 */
export const getChangeboardingOverrideFeature = (
  allowlistEnv?: Set<string>,
): string | undefined => {
  try {
    if (typeof window === 'undefined' || !window.location?.href) {
      return;
    }

    // DO NOT allow this to be used in any environments except for the allowlist.
    const allowlist = allowlistEnv ?? ALLOWLIST_ENV;
    if (!allowlist.has(process.env.VITE_CANVAS_ENV ?? '')) {
      return;
    }

    // As an enforced last resort, DO NOT allow this to be used in production.
    if (process.env.VITE_CANVAS_ENV?.includes('prod')) {
      return;
    }

    // A small exception in this case, purely so that we don't need to add this
    // rather harmless query parameter through CFE and into the iframe URL.
    // Better we just keep it locally scoped as we definitely don't need this to
    // be a bridge/iframe concern.
    // eslint-disable-next-line no-restricted-syntax
    const url = new URL(window.parent.location.href);
    return url.searchParams.get('changeboarding') ?? undefined;
  } catch (e) {
    console.error(e);
  }

  return;
};
